import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b7fa38b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "emmaus-wrap py-5" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<p class=\"emmaus-intro text-center mb-5\" data-v-b7fa38b6> Pour une jeunesse chrétienne adulte, responsable et engagée </p><div class=\"info-box mb-5\" data-v-b7fa38b6><p data-v-b7fa38b6> Le <strong data-v-b7fa38b6>Parcours OMEGA</strong> est une véritable aubaine pour les jeunes ayant le niveau <strong data-v-b7fa38b6>BAC</strong> et jusqu’à <strong data-v-b7fa38b6>25 ans</strong>. </p><p data-v-b7fa38b6> Il leur offre des <strong data-v-b7fa38b6>outils</strong> et des <strong data-v-b7fa38b6>valeurs</strong> pour définir leur idéal de vie, dans une tension vers les sommets, les hauteurs et l’excellence. </p><p data-v-b7fa38b6> Inspiré par le <strong data-v-b7fa38b6>Christ, Ami des Jeunes</strong>, l’OMEGA de l’histoire humaine, ce parcours se déroule sur <strong data-v-b7fa38b6>deux ans</strong>, à raison de <strong data-v-b7fa38b6>deux week-ends par mois</strong>. </p></div><h4 class=\"section-subtitle text-center mb-4\" data-v-b7fa38b6> Notre vision pour les jeunes </h4>", 3)
const _hoisted_6 = { class: "row g-4 mb-5" }
const _hoisted_7 = { class: "emmaus-card" }
const _hoisted_8 = { class: "emmaus-number" }
const _hoisted_9 = { class: "section-box mb-5" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-subtitle mb-3" }, " Un parcours pour ", -1))
const _hoisted_11 = { class: "section-box mb-5" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-subtitle mb-3" }, " Des cours de qualité, modulables et à la carte ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, [
  /*#__PURE__*/_createTextVNode(" Ces enseignements s’appuient sur la "),
  /*#__PURE__*/_createElementVNode("strong", null, "Bible"),
  /*#__PURE__*/_createTextVNode(", la "),
  /*#__PURE__*/_createElementVNode("strong", null, "Théologie"),
  /*#__PURE__*/_createTextVNode(" et l’"),
  /*#__PURE__*/_createElementVNode("strong", null, "Histoire de l’Église"),
  /*#__PURE__*/_createTextVNode(" pour répondre aux grandes interrogations des jeunes sur Dieu, la foi et l’engagement chrétien dans la cité. ")
], -1))
const _hoisted_14 = { class: "section-box mb-5" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-subtitle mb-3" }, " Une offre spirituelle riche ", -1))
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"row g-4 mb-5\" data-v-b7fa38b6><div class=\"col-md-6\" data-v-b7fa38b6><div class=\"info-box\" data-v-b7fa38b6><h5 data-v-b7fa38b6>Accompagnement de qualité</h5><ul data-v-b7fa38b6><li data-v-b7fa38b6>Tutorat &amp; accompagnement institutionnel</li><li data-v-b7fa38b6>Mentorat : rencontres avec des personnalités inspirantes</li></ul></div></div><div class=\"col-md-6\" data-v-b7fa38b6><div class=\"info-box\" data-v-b7fa38b6><h5 data-v-b7fa38b6>Espaces de culture &amp; d’échanges</h5><p data-v-b7fa38b6> Le parcours OMEGA est un véritable creuset culturel à travers colloques, séminaires, journées académiques et espaces de débat. </p></div></div></div>", 1)
const _hoisted_17 = { class: "section-box mb-5" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-subtitle text-center mb-3" }, " 5 bonnes raisons pour s’inscrire ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cost-box" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Coût de la formation"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "70 000 FCFA par an"),
    /*#__PURE__*/_createTextVNode(", payables en "),
    /*#__PURE__*/_createElementVNode("strong", null, "deux tranches")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-2 fw-bold" }, " Parcours OMEGA, une aide assurée aux parents quant à l’avenir de leurs enfants. ")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = { class: "year-tabs text-center mb-4" }
const _hoisted_24 = { class: "year-title text-center mb-2" }
const _hoisted_25 = { class: "year-note text-center mb-4" }
const _hoisted_26 = { class: "row g-4" }
const _hoisted_27 = { class: "module-card" }
const _hoisted_28 = { class: "module-title" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = { class: "section-box mb-5" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-subtitle mb-3 text-center" }, "Tribunes Réussir", -1))
const _hoisted_34 = { class: "mt-2 fst-italic text-center" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/Depliant.pdf",
    download: "Depliant.pdf",
    class: "btn-download me-3"
  }, " Télécharger Dépliant ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.visions, (vision, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-4",
            key: i
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(i + 1), 1),
              _createElementVNode("p", null, _toDisplayString(vision), 1)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.objectives, (obj, i) => {
            return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(obj), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.courses, (course, i) => {
            return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(course), 1))
          }), 128))
        ]),
        _hoisted_13
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.spiritualOffer, (spi, i) => {
            return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(spi), 1))
          }), 128))
        ])
      ]),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.reasons, (reason, i) => {
            return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(reason), 1))
          }), 128))
        ])
      ]),
      _hoisted_19,
      _hoisted_20,
      _hoisted_21,
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("button", {
          class: _normalizeClass(["year-tab", { active: $data.activeYear === 1 }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.activeYear = 1))
        }, "1ère année", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["year-tab", { active: $data.activeYear === 2 }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.activeYear = 2))
        }, "2ème année", 2)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.years, (year) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: year.id
        }, [
          _createElementVNode("h4", _hoisted_24, _toDisplayString(year.title), 1),
          _createElementVNode("p", _hoisted_25, _toDisplayString(year.note), 1),
          _createElementVNode("div", _hoisted_26, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(year.modules, (module, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-md-6",
                key: i
              }, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("h5", _hoisted_28, _toDisplayString(module.name), 1),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(module.courses, (course, j) => {
                      return (_openBlock(), _createElementBlock("li", { key: j }, _toDisplayString(course), 1))
                    }), 128))
                  ])
                ])
              ]))
            }), 128))
          ]),
          _hoisted_29,
          _hoisted_30,
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tribunes, (tribune, i) => {
                return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(i + 1) + ". " + _toDisplayString(tribune), 1))
              }), 128))
            ]),
            _createElementVNode("p", _hoisted_34, _toDisplayString($data.tribunesNote), 1)
          ]),
          _hoisted_35
        ])), [
          [_vShow, $data.activeYear === year.id]
        ])
      }), 128))
    ])
  ]))
}